"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  CARD_CLOSE_DELAY: true,
  ORGANIZER_COOKIE: true,
  NOTIFICATION_COOKIE: true,
  NOTIFICATION_COOKIE_EXPIRATION_SECONDS: true,
  FOLLOW_DONE_CUSTOM_METRIC_DATA: true,
  FOLLOW_READY_CUSTOM_METRIC_MARK: true,
  loginModalContainerClassName: true,
  gdprModalContainerClassName: true,
  followNotificationContainerClassName: true,
  LOGIN_CONFIRMATION_PATH: true,
  UNAUTHORIZED_ERROR_CODE: true,
  ERROR_FOLLOW: true,
  ERROR_UNFOLLOW: true,
  ERROR_ORG_INFO: true,
  ERROR_USER_INFO: true
};
exports.ERROR_USER_INFO = exports.ERROR_ORG_INFO = exports.ERROR_UNFOLLOW = exports.ERROR_FOLLOW = exports.UNAUTHORIZED_ERROR_CODE = exports.LOGIN_CONFIRMATION_PATH = exports.followNotificationContainerClassName = exports.gdprModalContainerClassName = exports.loginModalContainerClassName = exports.FOLLOW_READY_CUSTOM_METRIC_MARK = exports.FOLLOW_DONE_CUSTOM_METRIC_DATA = exports.NOTIFICATION_COOKIE_EXPIRATION_SECONDS = exports.NOTIFICATION_COOKIE = exports.ORGANIZER_COOKIE = exports.CARD_CLOSE_DELAY = void 0;

var _copy = require("./copy");

Object.keys(_copy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _copy[key];
    }
  });
});

var _googleAnalytics = require("./googleAnalytics");

Object.keys(_googleAnalytics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _googleAnalytics[key];
    }
  });
});

var _styles = require("./styles");

Object.keys(_styles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _styles[key];
    }
  });
});
var CARD_CLOSE_DELAY = 500; // Cookies

exports.CARD_CLOSE_DELAY = CARD_CLOSE_DELAY;
var ORGANIZER_COOKIE = 'ebOrganizerId';
exports.ORGANIZER_COOKIE = ORGANIZER_COOKIE;
var NOTIFICATION_COOKIE = 'ebFollowOrganizerNotification';
exports.NOTIFICATION_COOKIE = NOTIFICATION_COOKIE;
var NOTIFICATION_COOKIE_EXPIRATION_MONTHS = 3;
var NOTIFICATION_COOKIE_EXPIRATION_SECONDS = 60 * 60 * 24 * 30 * NOTIFICATION_COOKIE_EXPIRATION_MONTHS; // Web Performance

exports.NOTIFICATION_COOKIE_EXPIRATION_SECONDS = NOTIFICATION_COOKIE_EXPIRATION_SECONDS;
var FOLLOW_DONE_CUSTOM_METRIC_DATA = 'organizer-followed';
exports.FOLLOW_DONE_CUSTOM_METRIC_DATA = FOLLOW_DONE_CUSTOM_METRIC_DATA;
var FOLLOW_READY_CUSTOM_METRIC_MARK = 'follow-organizer-ready';
exports.FOLLOW_READY_CUSTOM_METRIC_MARK = FOLLOW_READY_CUSTOM_METRIC_MARK;
var loginModalContainerClassName = 'js-follow-organizer-login-container';
exports.loginModalContainerClassName = loginModalContainerClassName;
var gdprModalContainerClassName = 'js-gdpr-container';
exports.gdprModalContainerClassName = gdprModalContainerClassName;
var followNotificationContainerClassName = 'js-follow-organizer-notification';
exports.followNotificationContainerClassName = followNotificationContainerClassName;
var LOGIN_CONFIRMATION_PATH = '/signin/confirmation/';
exports.LOGIN_CONFIRMATION_PATH = LOGIN_CONFIRMATION_PATH;
var UNAUTHORIZED_ERROR_CODE = 403; // Errors

exports.UNAUTHORIZED_ERROR_CODE = UNAUTHORIZED_ERROR_CODE;
var ERROR_FOLLOW = 'follow';
exports.ERROR_FOLLOW = ERROR_FOLLOW;
var ERROR_UNFOLLOW = 'unfollow';
exports.ERROR_UNFOLLOW = ERROR_UNFOLLOW;
var ERROR_ORG_INFO = 'getOrgInfo';
exports.ERROR_ORG_INFO = ERROR_ORG_INFO;
var ERROR_USER_INFO = 'getUSer';
exports.ERROR_USER_INFO = ERROR_USER_INFO;
//# sourceMappingURL=index.js.map